export const permissionsKeys = {
  all: ['permissions'] as const,
  lists: () => [...permissionsKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...permissionsKeys.lists(), filters] as const,
};
